export default "__VITE_ASSET__ByQAd20t__"